import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  Box, TextField, Button, Typography, CircularProgress, Alert,
} from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import axios from "axios";
import api from "../components/utils/api";
import Logo from "../Img/IRON_Logo blanco sin fondo.svg";

export default function SetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const isReset = params.get("reset") === "1";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setError("");
    if (!password || password.length < 6) {
      return setError("La contraseña debe tener al menos 6 caracteres.");
    }
    if (password !== confirm) {
      return setError("Las contraseñas no coinciden.");
    }
    if (!token) {
      return setError("Token inválido. Usá el enlace del email.");
    }
    try {
      setLoading(true);
      await axios.post(api.urlAPI + "auth/set-password", { token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || "Ocurrió un error. Intentá de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      bgcolor: "#111318",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      p: 2,
    }}>
      {/* Logo */}
      <Box sx={{ mb: 3 }}>
        <img src={Logo} alt="Iron Group" height={44} />
      </Box>

      <Box sx={{
        bgcolor: "#1c1f27",
        border: "1px solid #2a2d36",
        borderRadius: 3,
        p: 3,
        width: "100%",
        maxWidth: 400,
      }}>
        {success ? (
          <Box sx={{ textAlign: "center", py: 2 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 52, color: "#4ade80", mb: 1.5 }} />
            <Typography sx={{ fontSize: 17, fontWeight: 600, color: "#e8e9ef", mb: 1 }}>
              {isReset ? "¡Contraseña actualizada!" : "¡Contraseña creada!"}
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#888", mb: 3 }}>
              Ya podés iniciar sesión con tu nueva contraseña.
            </Typography>
            <Button
              fullWidth
              onClick={() => navigate("/auth/login")}
              sx={{
                bgcolor: "#ED9519", color: "#1a0e00", fontWeight: 600,
                borderRadius: 2, py: 1.2,
                "&:hover": { bgcolor: "#d4851a" },
              }}
            >
              Ir al login
            </Button>
          </Box>
        ) : (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 2.5 }}>
              <LockResetIcon sx={{ color: "#ED9519", fontSize: 24 }} />
              <Typography sx={{ fontSize: 17, fontWeight: 600, color: "#e8e9ef" }}>
                {isReset ? "Nueva contraseña" : "Crear contraseña"}
              </Typography>
            </Box>

            <Typography sx={{ fontSize: 12, color: "#888", mb: 2.5 }}>
              {isReset
                ? "Elegí una contraseña nueva para reemplazar la anterior."
                : "Elegí una contraseña segura para acceder al sistema Iron Group."}
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2, fontSize: 12 }}>{error}</Alert>
            )}

            <TextField
              fullWidth
              label="Nueva contraseña"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              sx={{ mb: 1.5 }}
              inputProps={{ minLength: 6 }}
            />
            <TextField
              fullWidth
              label="Confirmar contraseña"
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              sx={{ mb: 2.5 }}
            />

            <Button
              fullWidth
              onClick={handleSubmit}
              disabled={loading}
              sx={{
                bgcolor: "#ED9519", color: "#1a0e00", fontWeight: 600,
                borderRadius: 2, py: 1.2,
                "&:hover": { bgcolor: "#d4851a" },
                "&.Mui-disabled": { bgcolor: "#6b5010", color: "#888" },
              }}
            >
              {loading ? <CircularProgress size={20} sx={{ color: "#1a0e00" }} /> : "Crear contraseña"}
            </Button>
          </>
        )}
      </Box>

      <Typography sx={{ fontSize: 11, color: "#444", mt: 3 }}>
        Iron Group S.A. · {new Date().getFullYear()}
      </Typography>
    </Box>
  );
}
